import { ExternalLink } from '@/atoms/ExternalLink'
import { Image } from '@/atoms/Image'
import { TitleLG } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useTranslate } from '@/utils/translate/translate-client'

export const FollowSection: React.FC = () => {
  const { t } = useTranslate('music')

  return (
    <section className="relative flex w-full items-center justify-center pt-2 lg:pt-20">
      <div className="flex flex-col items-center justify-center rounded-2xl p-4 text-center text-white lg:py-6">
        <TitleLG weight="bold" className="max-w-[360px]">
          {t('followUsOnYourFavoriteMusicProvider', 'Follow us on your favorite music service provider')}
        </TitleLG>
        <div className="flex flex-row gap-6 pt-6 lg:gap-8">
          <ExternalLink href={'https://open.spotify.com/artist/2Q04nRZfHm5oBF9Z14dpUF?si=VLxjOz6vRHKcTeL6uhecAA&go=1'}>
            <div className="max-h-10 max-w-10 transition-transform duration-300 hover:scale-[1.03] lg:max-h-12 lg:max-w-12">
              <Image
                className="w-full rounded-2xl object-contain"
                src={getCloudinaryImageUrl({ path: 'v1764947897/angel-studios/music/icons/Spotify_icon.svg.png' })}
                alt={t('spotifyLogo', 'Spotify Logo')}
                width={0}
                height={0}
                sizes="100vw"
              />
            </div>
          </ExternalLink>
          <ExternalLink
            href={
              'https://music.apple.com/us/artist/1848973710?app=music&at=1l3vpUI&ct=LFV_b6298349a614b2c359c7ea0c7260d805&itscg=30440&itsct=catchall_p2&lId=214762200&cId=none&sr=2&src=Linkfire&ls=1'
            }
          >
            <div className="max-h-10 max-w-10 transition-transform duration-300 hover:scale-[1.03] lg:max-h-12 lg:max-w-12">
              <Image
                className="w-full rounded-2xl object-contain"
                src={getCloudinaryImageUrl({
                  path: 'v1764947896/angel-studios/music/icons/Apple_Music_icon',
                })}
                alt={t('appleMusicLogo', 'Apple Music Logo')}
                width={0}
                height={0}
                sizes="100vw"
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
          </ExternalLink>
        </div>
      </div>
    </section>
  )
}
